<template>
    <footer class="footer">
      <div class="footer-inner">
        <h4>数字商机港 · 专注B2B电子商务服务</h4>
        <p>汇集海量产品与企业服务数据，为企业提供高效推广</p>
        <a class="note" @click="goToExternalSite">鲁ICP备2022032657号-2</a>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'AppFooter',
    methods: {
      goToExternalSite() {
        // 在新窗口打开备案查询页面
        window.open('https://beian.miit.gov.cn', '_blank')
      }
    }
  }
  </script>
  
  <style scoped>
  .footer {
    margin-top: 50px;
    padding: 40px 0 25px;
    border-top: 2px solid #e8e8e8;
    text-align: center;
  }
  .footer h4 {
    font-size: 18px;
    color: #222;
    margin-bottom: 10px;
  }
  .footer p {
    color: #777;
    font-size: 14px;
    margin: 6px 0;
  }
  .footer .note {
    font-size: 13px;
    color: #aaa;
    cursor: pointer;
    text-decoration: none;
    transition: color 0.2s;
  }
  .footer .note:hover {
    color: #c0392b;
    text-decoration: underline;
  }
  </style>